export class Block {
  id: number;
  description: string;

}
